/**
 * @file 归属地卡
 * @author chenyuyang
 */
import React from 'react';
import PropTypes from 'prop-types';
import iconPhone from '../../imgs/icon-phone.svg';
import './style.less';

const Location = (props) => {
    const {data = {}, search} = props || {};
    const operator = ((data.location?.province || '') + ' ' + (data.location?.operator || '')) || '';
    const local = data.location?.area[0].city || '';
    return (
        <div className="comp-location">
            <p className="tel-num">{search}</p>
            <div className="tel-info">
                <img className="icon" src={iconPhone}></img>
                <div className="info-right">
                    <div className="location-wrapper">
                        <span className="location-name">{local}</span>
                    </div>
                    <p className="location">{operator}</p>
                </div>
            </div>
        </div>
    );
};
Location.propTypes = {
    search: PropTypes.string,
    data: PropTypes.any
};
export default Location;